import React from 'react'
import buildLinkContextItems from '../../../api/marketing/buildLinkContextItems'

function LinkContextCell({ row }) {
  const items = buildLinkContextItems(row)

  if (!items.length) {
    return <span>—</span>
  }

  return (
    <div className="MarketingLinks-ContextCell">
      {items.map((item, index) => (
        <span key={index} className="MarketingLinks-ContextChip" title={item.title}>
          {item.label}
        </span>
      ))}
    </div>
  )
}

export default LinkContextCell
